import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type {
  UserAddTradeSearchCreatePayload,
  UserDeleteTradeSearchCreatePayload,
} from '@blade/trade-api-client'

export const fetchUserRecentSearchesRequestAction = action(
  async (ctx, { network }: { network: Network.Network }) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userRecentTradeSearchesList, [
        {
          network: Network.toDto(network),
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchUserRecentSearchesRequestAction',
)

export const addPairToRecentSearchesRequestAction = action(
  async (ctx, req: UserAddTradeSearchCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userAddTradeSearchCreate, [req]),
    )
    return pipe(result, Result.mapError(ApiError.fallbackToUnknown))
  },
  'addPairToRecentSearchesRequestAction',
)

export const deletePairFromRecentSearchesRequestAction = action(
  async (ctx, req: UserDeleteTradeSearchCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userDeleteTradeSearchCreate, [req]),
    )
    return pipe(result, Result.mapError(ApiError.fallbackToUnknown))
  },
  'deletePairFromRecentSearchesRequestAction',
)
